import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../components/ui/card";
import { Label } from "../components/ui/label";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";

export const FixedCostsCard = ({
  t,
  churchPriest,
  churchFlowers,
  decorations,
  showChurchPriest,
  showChurchFlowers,
  showDecorations,
  onChurchPriestChange,
  onChurchFlowersChange,
  onDecorationsChange,
  setShowChurchPriest,
  setShowChurchFlowers,
  setShowDecorations,
  customItems,
  onAddItem,
  onRemoveItem,
  onItemChange,
  formatMoneyValue,
}) => (
  <Card className="relative overflow-visible">
    <CardHeader>
      <CardTitle>{t("fixed.cardTitle")}</CardTitle>
      <CardDescription>{t("fixed.cardDescription")}</CardDescription>
    </CardHeader>
    <CardContent>
      <div className="grid gap-4 sm:grid-cols-2">
        {showChurchPriest && (
          <div className="space-y-2 flex items-end justify-between gap-2">
            <div className="flex-1 space-y-2">
              <Label>{t("fixed.priestLabel")}</Label>
              <Input
                type="text"
                inputMode="decimal"
                value={formatMoneyValue(churchPriest)}
                onChange={(e) => onChurchPriestChange(e.target.value)}
                placeholder={t("fixed.amountPlaceholder")}
              />
            </div>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => {
                setShowChurchPriest(false);
                onChurchPriestChange("");
              }}
            >
              {t("fixed.removeButton")}
            </Button>
          </div>
        )}

        {showChurchFlowers && (
          <div className="space-y-2 flex items-end justify-between gap-2">
            <div className="flex-1 space-y-2">
              <Label>{t("fixed.flowersLabel")}</Label>
              <Input
                type="text"
                inputMode="decimal"
                value={formatMoneyValue(churchFlowers)}
                onChange={(e) => onChurchFlowersChange(e.target.value)}
                placeholder={t("fixed.amountPlaceholder")}
              />
            </div>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => {
                setShowChurchFlowers(false);
                onChurchFlowersChange("");
              }}
            >
              {t("fixed.removeButton")}
            </Button>
          </div>
        )}

        {showDecorations && (
          <div className="space-y-2 sm:col-span-2 flex items-end justify-between gap-2">
            <div className="flex-1 space-y-2">
              <Label>{t("fixed.decorationsLabel")}</Label>
              <Input
                type="text"
                inputMode="decimal"
                value={formatMoneyValue(decorations)}
                onChange={(e) => onDecorationsChange(e.target.value)}
                placeholder={t("fixed.amountPlaceholder")}
              />
            </div>
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => {
                setShowDecorations(false);
                onDecorationsChange("");
              }}
            >
              {t("fixed.removeButton")}
            </Button>
          </div>
        )}
      </div>

      <div className="mt-4 space-y-2">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2 text-xs text-slate-600">
            <Label>{t("fixed.customLabel")}</Label>
          </div>

          {/* Add button with tooltip */}
          <div className="relative inline-flex group">
            <Button
              variant="outline"
              size="sm"
              type="button"
              onClick={onAddItem}
            >
              {t("fixed.addButton")}
            </Button>
            <div
              className="pointer-events-none absolute right-0 top-full mt-1 w-56 rounded-md border border-slate-200
  bg-white px-3 py-2 text-[11px] text-slate-600 shadow-md opacity-0 group-hover:opacity-100 transition-opacity z-20"
            >
              {t("fixed.addTooltip")}
            </div>
          </div>
        </div>
        <div className="space-y-2">
          {customItems.map((item, index) => (
            <div
              key={index}
              className="grid gap-2 sm:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_auto]"
            >
              <input
                className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm outline-none focus-visible:ring-2 focus-visible:ring-rose-400"
                placeholder={t("fixed.customItemPlaceholder")}
                value={item.label}
                onChange={(e) => onItemChange(index, "label", e.target.value)}
              />
              <Input
                type="text"
                inputMode="decimal"
                placeholder={t("fixed.amountPlaceholder")}
                value={formatMoneyValue(item.amount)}
                onChange={(e) => onItemChange(index, "amount", e.target.value)}
              />
              <Button
                type="button"
                variant="ghost"
                size="sm"
                onClick={() => onRemoveItem(index)}
              >
                {t("fixed.removeButton")}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </CardContent>
  </Card>
);
